module.exports = __webpack_public_path__ + "static/media/Paypal.a4d10911.png";